import { ComponentFactory, ComponentFactoryResolver, Directive, ViewContainerRef
       } from '@angular/core';

import { ActionBarComponent } from './action-bar.component';

@Directive({
  selector: '[action-bars]',
})
export class ActionBarDirective {
  private factory: ComponentFactory<ActionBarComponent>;

  constructor(
      private viewContainerRef: ViewContainerRef,
      componentFactoryResolver: ComponentFactoryResolver
  )
  {
    this.factory =
        componentFactoryResolver.resolveComponentFactory(ActionBarComponent);
  }

  public createComponent(): ActionBarComponent
  {
    const componentRef =
        this.viewContainerRef.createComponent(this.factory);
    const component = componentRef.instance;
    component.componentRef = componentRef;
    const loaderComponentElement = component.nativeElement;
    const parent: Node = loaderComponentElement.parentNode;
    parent.insertBefore(loaderComponentElement, parent.firstChild);
    return component;
  }
}



// WEBPACK FOOTER //
// ./src/app/collage-designer/stage/placeholder/overlays/action-bar/action-bar.directive.ts